<img src="assets/icons/rms-icon-flag.svg" alt="price targets tied to comp flag" class="img-icon ml-1"
    *ngIf="priceComp?.active" [placement]="placement" container="body"
    [ngbPopover]="popContent" popoverClass="narrow-popover" triggers="mouseenter:mouseleave">
<ng-template #popContent>
  <div>LT % - Dec: <span class="bold">{{priceComp?.priceTarget?.long?.percentChange | rmsNumberTransform: false: 0}}</span></div>
  <div>FV: <span class="bold">{{priceComp?.priceTarget?.fair?.percentChange | rmsNumberTransform: false: 0}} of {{priceComp?.companyComparatorName}}</span></div>
  <div>ST % - Inc: <span class="bold">{{priceComp?.priceTarget?.short?.percentChange | rmsNumberTransform: false: 0}}</span></div>
</ng-template>
